const countryDrawer = {
  en: {
    priorityCountries: {
      USA: "Your UnionPay Card is accepted by 99% of places in the U.S. among places that take credit cards*.",
      JPN: "Your card is accepted almost everywhere that takes credit cards in Japan.",
      PER: "Your card is accepted almost everywhere that takes credit cards in Peru.",
      ESP: "You can use your card almost everywhere here, including many top merchants in Barcelona, Madrid, and Seville.",
      URY: "You can use your card almost everywhere here, including many popular destinations in Montevideo, Punta del Este and Colonia del Sacramento.",
      ARG: "Many locations take your card, including many popular destinations in Buenos Aires and Mendoza.",
      CHL: "Many locations take your card, including many popular destinations in Santiago.",
      DEU: "Many locations take your card, including many top merchants in Berlin.",
      MEX: "Many locations take your card, including hundreds of top merchants in Cancun.",
      GBR: "Many locations take your card, including many top merchants in London.",
      CAN: "Many locations take your card, including many of the most popular merchants in Vancouver and Toronto.",
      ITA: "A growing number of locations take your card, including many popular merchants in Rome.",
      PRT: "A growing number of locations take your card, including many popular merchants in Lisbon.",
      AUS: "Select locations accept your card, including top destinations in Sydney, Melbourne and Brisbane.",
      FRA: "Select locations accept your card, including many of the most popular merchants in Paris.",
    },
    acceptanceMarkHeadline: {
      coverage: "Take your card wherever you go",
      noCoverage: "Traveling in the region? Take your card",
    },
    aboveMarksCopy: {
      coverage: "What to look for when you pay in ",
      noCoverage: {
        Europe: "What to look for when you pay in Europe",
        Africa: "In-network Payments in the Middle East & Africa",
        Asia: "In-network Payments in Asia Pacific",
        America: "What to look for when you pay in the Americas",
      },
    },
    acceptanceATMcoverage:
      "Your card is part of a global network, so you can use it anywhere you see these logos. Don't see any? Just ask.",
    noAcceptanceATMcoverage: {
      Europe:
        "You card is part of a growing global network. You can use your card across some of Europe's most popular destinations, including Spain, Germany, the UK, Italy, Portugal and France.",
      Africa:
        "You card is part of a growing global network. Use your card in the UAE, Egypt, Morocco and South Africa. With destinations in the Middle East & Africa expanding rapidly, you can use your card in more and more places here.",
      Asia: "Your card is part of a growing global network. Use your card almost everywhere in Japan as well as top travel destinations across Asia and Pacific Islands, including India, China, Singapore, Australia and more.",
      America:
        "Your card is part of a growing global network. You can use your card across Canada, Mexico and the U.S., as well as in popular South American travel spots like Peru, Uruguay, Argentina, Chile and more.",
    },
    regions: {
      Europe: "Europe",
      Africa: "the Middle East & Africa",
      Asia: "Asia Pacific",
      America: "the Americas",
    },
    atm: {
      coverage: {
        headline: "Need cash while you’re here?",
        subtitle: "Use your card to get local currency at these ATMs:",
        supplmentary:
          "All banks displaying Discover Network, Diners Club International and the PULSE Logos",
        fees: "Fees may apply.",
      },
      coverageAlt: {
        headline: "You can use your card at these ATMs",
        subtitle: "Use your card to get local currency at these ATMs:",
        supplmentary:
          "All banks displaying Discover Network, Diners Club International and the PULSE Logos",
        fees: "Fees may apply.",
      },
      noCoverage: {
        headline: "ATM coverage is emerging",
        subtitle: "We are working to establish ATM acceptance in this country.",
      },
    },
  },
  es: {},
};

export default countryDrawer;
